const transactionData = [
  {
    id: "TU5190",
    createdTime: "04/03/2026 14:11:23",
    type: "ATM transfer",
    customer: { name: "thuynga02", email: "thuynga02@yopmail.com" },
    amount: "5 SGD",
    status: "Pending",
  },
  {
    id: "TU5189",
    createdTime: "04/03/2026 14:11:10",
    type: "Bank transfer",
    customer: { name: "thuynga02", email: "thuynga02@yopmail.com" },
    amount: "1 SGD",
    status: "Pending",
  },
  {
    id: "TU5188",
    createdTime: "04/03/2026 14:09:26",
    type: "UEN",
    customer: { name: "thuynga02", email: "thuynga02@yopmail.com" },
    amount: "3 SGD",
    status: "Pending",
  },
  {
    id: "TU5187",
    createdTime: "04/03/2026 14:09:00",
    type: "PayNow QR",
    customer: { name: "thuynga02", email: "thuynga02@yopmail.com" },
    amount: "12 SGD",
    status: "Pending",
  },
  {
    id: "TU5181",
    createdTime: "03/03/2026 11:54:10",
    type: "PayNow QR",
    customer: { name: "thuynga02", email: "thuynga02@yopmail.com" },
    amount: "473.48 SGD",
    status: "Approved",
  },
];
export default transactionData;
